"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterActions = void 0;
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var IFilterAction_1 = require("../../../../../../interfaces/IFilterAction");
var GIFT_TYPES = [
    { label: "All", value: "ALL" },
    { label: "Voucher", value: "VOUCHER" },
    { label: "Wallet", value: "WALLET" },
];
function useFilterActions() {
    var _a = (0, react_1.useState)(null), selectedType = _a[0], setSelectedType = _a[1];
    var _b = (0, react_1.useState)(null), selectedFromDate = _b[0], setSelectedFromDate = _b[1];
    var _c = (0, react_1.useState)(null), selectedToDate = _c[0], setSelectedToDate = _c[1];
    var onTypeSelected = (0, react_1.useCallback)(function (value) {
        setSelectedType(value);
    }, []);
    var onSetSelectedFromDates = (0, react_1.useCallback)(function (value) {
        setSelectedFromDate(doshx_controls_web_1.Utilities.formatDateTime(value, "YYYY-MM-DD"));
    }, []);
    var onSetSelectedToDates = (0, react_1.useCallback)(function (value) {
        setSelectedToDate(doshx_controls_web_1.Utilities.formatDateTime(value, "YYYY-MM-DD"));
    }, []);
    var filterActions = (0, react_1.useMemo)(function () { return [
        {
            type: IFilterAction_1.FilterTypeEnum.Dates,
            key: "from_date",
            label: "From Date",
            value: selectedFromDate,
            onChange: onSetSelectedFromDates,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.Dates,
            key: "to_date",
            label: "To Date",
            value: selectedToDate,
            onChange: onSetSelectedToDates,
        },
        {
            type: IFilterAction_1.FilterTypeEnum.RadioGroup,
            key: "type",
            label: "Type",
            value: selectedType,
            options: GIFT_TYPES,
            onChange: onTypeSelected,
            defaultOpen: true,
        },
    ]; }, [onTypeSelected, selectedType, onSetSelectedFromDates, selectedFromDate, onSetSelectedToDates, selectedToDate]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setSelectedType(null);
        setSelectedFromDate(null);
        setSelectedToDate(null);
    }, []);
    (0, react_1.useEffect)(function () {
        resetFilters();
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        filterActions: filterActions,
    }); }, [filterActions]);
}
exports.useFilterActions = useFilterActions;
